import PostAddIcon from "@mui/icons-material/PostAdd";
import ListCatalog from "./List";
import CreateCatalog from "./Create";
import EditCatalog from "./Edit";
import ShowCatalog from "./Show";

//params
export const EDITIONS_CATALOG = "editions/catalog";
//permissions

export const resources = {
  isMenu: true,
  icon: <PostAddIcon />,
  name: EDITIONS_CATALOG,
  title: "Каталог",
  list: <ListCatalog />,
  create: <CreateCatalog />,
  edit: <EditCatalog />,
  show: <ShowCatalog />,
  permission: "editions",
};

//api url
